import React from 'react';
import ActionButton from './action-button';

const AddButton = ({action, disabled, errorHandler, children}) => {
  return <ActionButton className="btn-sm btn-success"
                       action={() => action()}
                       errorHandler={errorHandler}
                       disabled={disabled}>
    {children || <span className="material-icons align-middle" style={{fontSize: '20px'}}>&#xE145;</span>}
  </ActionButton>;
};
export default AddButton;
